import {useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS} from './keys'
// import {useGetRepresentedUser} from '@/hooks/useGetRepresentedHost'
import {useMe} from '@/features/authentication/queries/useMe'
import {UserV3} from '@/features/authentication/types'
import {ROUTE_MESSAGE_CENTER_CHAT} from '@/utilities/constants/routeNames'
import {getCorrectUserId} from '@/utilities/helpers'
import {generatePath, useNavigate} from 'react-router-dom'
import {Broadcast, CreateBroadcastPayload} from '../chat.model'
import {createBroadcastGroup} from '../services/chat.http'
import {UserRoleE} from '@/types'
import {LocalStorageManager} from '@/utilities/localStorage'

export const useCreateBroadcastV3 = ({onSuccess}: {onSuccess?: (data: Broadcast) => void}) => {
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const {data: user} = useMe()

    const isRepresentative = user?.type === UserRoleE.Representative
    const representedCreatorId: string | number | undefined = isRepresentative
        ? LocalStorageManager.chatUserId.get()
        : undefined

    const representedUserId: string | number | undefined = getCorrectUserId(user as UserV3)

    return useMutation({
        mutationKey: [MUTATION_KEYS.createBroadcast],
        mutationFn: (payload: CreateBroadcastPayload) => createBroadcastGroup(payload, representedCreatorId),
        onSuccess: data => {
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.getGroupListV3, representedUserId]})
            onSuccess?.(data)
            navigate(
                generatePath(ROUTE_MESSAGE_CENTER_CHAT, {
                    channel: `group-${data.id}`
                })
            )
        }
    })
}
